<script setup lang="ts">
const year = new Date().getFullYear();
</script>

<template>
  <footer class="site-footer">
    <div class="container">
      <p>
        © {{ year }} RanaVolt · Solar systems for Nigerian homes &amp; SMEs.
      </p>
      <p class="sub">
        <a href="/about">About</a> · <a href="/contact">Contact</a> ·
        <a href="/faq">FAQ</a>
      </p>
    </div>
  </footer>
</template>

<style scoped>
.site-footer {
  background: var(--rv-cream);
  border-top: 1px solid var(--rv-border);
  padding: var(--rv-space-10) 0;
  text-align: center;
  color: var(--rv-text-muted);
  font-size: 0.9rem;
}
.sub {
  margin-top: var(--rv-space-2);
}
.sub a {
  color: var(--rv-text-muted);
}
.sub a:hover {
  color: var(--rv-green);
}
</style>
